import { Injectable } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/services/api.service';
import { ApiResponse } from '../../../core/shared/classes/api';
import { TablePaginate } from '../../../shared/classes/table-paginate';
import { Sort } from '@angular/material';
import {PersonneContact} from "../classes/personne-contact";
import {Role} from "../classes/role";
import {map} from "rxjs/operators";
import { AclRole } from '../classes/acl_role';
import { Bureau } from '../../../core/shared/classes/bureau';


@Injectable()
export class IdentiteService {

    constructor (private apiService: ApiService) {}

    getProspects(paginate?: TablePaginate, sort?: Sort): Observable<ApiResponse> {
        return this.apiService.get('role/prospect'
            + (paginate ? '/paginate/' + paginate.current + '/' + paginate.itemCountPerPage : '')
            + (sort ? '/sort/' + sort.active + '/' + sort.direction : '')
        );
    }

    getProprietaires(paginate?: TablePaginate, sort?: Sort): Observable<ApiResponse> {
        return this.apiService.get('role/proprietaire'
            + (paginate ? '/paginate/' + paginate.current + '/' + paginate.itemCountPerPage : '')
            + (sort ? '/sort/' + sort.active + '/' + sort.direction : '')
        );
    }

    getLocataires(paginate?: TablePaginate, sort?: Sort): Observable<ApiResponse> {
        return this.apiService.get('role/locataire'
            + (paginate ? '/paginate/' + paginate.current + '/' + paginate.itemCountPerPage : '')
            + (sort ? '/sort/' + sort.active + '/' + sort.direction : '')
        );
    }

    getByCodaRoles(paginate?: TablePaginate, sort?: Sort): Observable<ApiResponse> {
        return this.apiService.get('role/coda-roles'
            + (paginate ? '/paginate/' + paginate.current + '/' + paginate.itemCountPerPage : '')
            + (sort ? '/sort/' + sort.active + '/' + sort.direction : '')
        );
    }

    getUtilisateurs(option?: string, paginate?: TablePaginate, withoutAcl?: string, withoutBureau?: string, searchTerm?: string): Observable<ApiResponse> {
        return this.apiService.get('role/utilisateur/employe/1'
        + (paginate ? '/paginate/' + paginate.current + '/' + paginate.itemCountPerPage : '')
        + (option ? '/' + option : '')
        + (withoutAcl ? '/acl/' + withoutAcl : '')
        + (withoutBureau ? '/bureau/' + withoutBureau : '')
        + (searchTerm ? '/search/' + searchTerm : '')
        );
    }


    getIdentiteFiltered(role: string, paginate?: TablePaginate, sort?: Sort, filters?: any, employe?: string, archive?: string, option?: string): Observable<ApiResponse> {
        return this.apiService.post(
            'role-search/' + role
            + (archive ? '/archive/' + archive : '')
            + (employe ? '/employe/' + employe : '')
            + (paginate ? '/paginate/' + paginate.current + '/' + paginate.itemCountPerPage : '')
            + (sort ? '/sort/' + sort.active + '/' + sort.direction : '')
            + (option ? '/' + option : ''),
            filters
        );
    }

    getDetailsIdentite(id: any): Observable<ApiResponse> {
        return this.apiService.get('identite/' + id);
    }

    updateIdentite(id: any, data: any): Observable<ApiResponse> {
        return this.apiService.put('identite/' + id, data);
    }

    archiveIdentite(id: any, data: any): Observable<ApiResponse> {
        return this.apiService.put('archive-identite/' + id, data);
    }

    insertIdentite(data: any): Observable<ApiResponse> {
        return this.apiService.post('identite', data);
    }

    getCivilites(): Observable<ApiResponse> {
        return this.apiService.get('civilite');
    }

    getRolesUtilisateur(custom: boolean = null): Observable<ApiResponse> {
        return this.apiService.get(
            'employe'
            + (custom === null ? '' : (custom ? '/custom/1' : '/custom/0'))
        );
    }

    insertRolesUtilisateur(aclRole: AclRole, aclRoleIdOriginal: any = null): Observable<ApiResponse> {
        let data = null;
        if (aclRoleIdOriginal) {
            data = {...aclRole, acl_role_id_original: aclRoleIdOriginal};
        } else {
            data = {...aclRole};
        }
        return this.apiService.post('employe', data);
    }

    updateRolesUtilisateur(id: any, data: AclRole): Observable<ApiResponse> {
        return this.apiService.put('employe/' + id, data);
    }

    deleteRolesUtilisateur(id: any): Observable<ApiResponse> {
        return this.apiService.delete('employe/' + id);
    }

    deleteIdentite(id: string): Observable<ApiResponse> {
        return this.apiService.delete('identite/' + id);
    }

    exportCsvIdentite(data: any, employe: string = '0', aclRolesId: string = ''): Observable<ApiResponse> {
        return this.apiService.post('export-identite/employe/' + employe + '/acl-roles/' + aclRolesId, data);
    }

    getRecherchesIdentite(id: string): Observable<ApiResponse> {
        return this.apiService.get('identite-recherche/roleId/' + id);
    }

    getRecherchePrincipale(id: string): Observable<ApiResponse> {
        return this.apiService.get('identite-recherche/roleId/' + id + '/principale/1');
    }

    register(data: any): Observable<ApiResponse> {
        return this.apiService.post('identite/register/', data);
    }

    getIdentitesByTerm(term: string, roles?: string | string[]): Observable<ApiResponse> {
        // on encode les term pour ne pas avoir de soucis de caractères
        const safeTerm = encodeURIComponent(term ? term : '');
        // on récupère un array de roles afin de pouvoir faire la sélection sur plusieurs roles à la fois
        const list = Array.isArray(roles) ? roles.filter(Boolean) : (roles ? [roles] : []);
        const rolesSegment = list.length ? `/acl-role/${list.map(r => encodeURIComponent(r)).join(',')}` : '';
        const url = `identite/search/${safeTerm}${rolesSegment}`;

        return this.apiService.get(url);
    }

    getIdentitesByRoles(id: string, option?: string): Observable<ApiResponse> {
        const query = {};
        if (option) {
            query['option'] = option;
        }
        return this.apiService.get('identite/search/' + id, {}, query);
    }

    getEmployesByTerm(term: string, excludeBureauId?: string): Observable<ApiResponse> {
        return this.apiService.get('identite/employe/search/' + term
            + (excludeBureauId ? '/exclude-bureau/' + excludeBureauId : '')
        );
    }

    uploadPhoto(file: File, id: String, getEvent?: Function): Observable<ApiResponse> {
        const httpOptions = { reportProgress: true };
        const formData = new FormData();
        formData.append('fileKey', file);
        formData.append('name', file.name);
        return this.apiService.upload('upload/photo/resource/identite/resourceId/' + id, formData, getEvent);
    }


    getEtatIdentite(withAcl?: string): Observable<ApiResponse> {
        return this.apiService.get('etat-identite' + (withAcl ? '/acl/' + withAcl : ''));
    }

    insertEtatIdentite(data: any): Observable<ApiResponse> {
        return this.apiService.post('etat-identite', data);
    }

    updateEtatIdentite(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.put('etat-identite/' + id, data);
    }

    deleteEtatIdentite(id: string): Observable<ApiResponse> {
        return this.apiService.delete('etat-identite/' + id);
    }

    getLotsProprietaire(id: string, option?: string): Observable<ApiResponse> {
        const query = {};
        if (option) {
            query['option'] = option;
        }
        return this.apiService.get('proprietaire/lot/' + id, {}, query);
    }

    getLotsLocataire(id: string, option?: string): Observable<ApiResponse> {
        const query = {};
        if (option) {
            query['option'] = option;
        }
        return this.apiService.get('locataire/lot/' + id, {}, query);
    }

    getProprietairesLot(id: string): Observable<ApiResponse> {
        return this.apiService.get('lot-proprietaires/' + id);
    }

    getProprietairesBatiment(id: string): Observable<ApiResponse> {
        return this.apiService.get('batiment-proprietaires/' + id);
    }

    getLotProprietairesBatiment(id: string): Observable<ApiResponse> {
        return this.apiService.get('batiment-lot-proprietaires/' + id);
    }

    getBureau(id: string): Observable<ApiResponse> {
        return this.apiService.get('identite/' + id + '/bureau');
    }

    updateBureauConcerne(id: any, data: any): Observable<ApiResponse> {
        return this.apiService.put('identite/' + id + '/bureau-concerne', data);
    }

    getProvenance(): Observable<ApiResponse> {
        return this.apiService.get('provenance');
    }

    insertProvenance(data: any): Observable<ApiResponse> {
        return this.apiService.post('provenance', data);
    }

    updateProvenance(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.put('provenance/' + id, data);
    }

    deleteProvenance(id: string): Observable<ApiResponse> {
        return this.apiService.delete('provenance/' + id);
    }

    getModeContact(): Observable<ApiResponse> {
        return this.apiService.get('mode-contact');
    }

    insertModeContact(data: any): Observable<ApiResponse> {
        return this.apiService.post('mode-contact', data);
    }

    updateModeContact(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.put('mode-contact/' + id, data);
    }

    deleteModeContact(id: string): Observable<ApiResponse> {
        return this.apiService.delete('mode-contact/' + id);
    }

    exportCsvFilteredIdentites(aclRolesId: string = '', employe: string = '0', archive: string, filters = {}): Observable<ApiResponse> {
        return this.apiService.post('export-filtered-identite'
            + '/employe/' + employe
            + '/acl-roles/' + aclRolesId
            + (archive ? '/archive/' + archive : '')
            , filters);
    }


    fetchPersonnesContact(rolesId): Observable<Array<PersonneContact>> {
        return this.apiService.get(`personnes_contact/${rolesId}`).pipe(map(
            response => {
                if (response.data !== undefined) {
                    const res = [];
                    response.data.map(elem => {
                        res.push(new PersonneContact(elem));
                    });
                    return res;
                } else {
                    return [];
                }
            }
        ));
    }

    deletePersonneContact(rolesId, personneContactId): Observable<any> {
        return this.apiService.delete(`personnes_contact/${rolesId}/${personneContactId}`);
    }

    createPersonneContact(rolesId, role: Role) {
        return this.apiService.post(`personnes_contact/${rolesId}`, JSON.stringify({enfant: role}));
    }

    transfertAll(aclRolesId: string = '', filters = {}): Observable<ApiResponse> {
        return this.apiService.post('transfert-identite-all'
            + '/acl-roles/' + aclRolesId
            , filters);
    }
    transfertIdentite(data: any): Observable<ApiResponse> {
        return this.apiService.post('transfert-identite/', data);
    }

    checkIdentiteFournisseur(data: any):  Observable<ApiResponse> {
        return this.apiService.post('identite-check-fournisseur', data);
    }

    getIdentiteByRole(role): Observable<ApiResponse> {
        return this.apiService.get(`list/identite/role/${role}`);
    }

    getIdentiteByRoles(roles: string[]): Observable<ApiResponse> {
        const params = roles.map(role => `roles[]=${encodeURIComponent(role)}`).join('&');
        return this.apiService.get(`list/identite/roles?${params}`);
    }

    getProprietairePrincipalLot(lotId: string): Observable<ApiResponse> {
        return this.apiService.get('lot-proprietaire-principal/' + lotId);
    }

    getDashboard(id:any): Observable<ApiResponse> {
        return this.apiService.get('dashboard-layout/get/' + id + '/a17/1');
    }

    saveDashboard(id: any, data: any): Observable<ApiResponse> {
        return this.apiService.post('dashboard-layout/save/' + id + '/a17/1', data);
    }

    getRoleByIdentite(id: any): Observable<ApiResponse> {
        return this.apiService.get(`role/identite/${id}`);
    }

    getIdentitePeppolFiltered(role: string, bureau?: Bureau, filters?: any, sort?: Sort): Observable<ApiResponse> {
        return this.apiService.post('identite-peppol/role/' + role + '/bureau/' + bureau + (sort ? '/sort/' + sort.active + '/' + sort.direction : ''), filters);
    }

    exportPeppolCsv(data, identiteType): Observable<ApiResponse> {
        return this.apiService.post(`export-csv/peppol/${identiteType}`, data);
    }

}
